import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation newNotificationTemplate(
    $name: String!,
    $template: String!,
  ) {
  newNotificationTemplate(
    name: $name,
    template: $template,
  ) {
      success
      id
    }
  }
`;

export function useNewNotificationTemplate() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNotificationTemplate.id);
      }
    });
  };
  return { data, isLoading, run };
}
